export const SOURCE_ADD_RG = 'add-rg'
export const SOURCE_ADD_USER = 'add-user'
export const SOURCE_COLD_RG = 'cold-transfer-rg'
export const SOURCE_COLD_USER = 'cold-transfer-user'
export const SOURCE_CALL_WAITING = 'call-waiting'
